function decodeRichTextEntities(value: string): string {
  return (
    value
      // Decode named entities before &amp; so double-encoded sequences like &amp;lt; stay &lt;.
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;|&apos;|&#x27;/gi, "'")
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
  );
}

function decodedRichTextToPlainText(value: string): string {
  return value
    .replace(/<\/?[a-z][^>]*>/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function richTextToPlainText(value: string | undefined): string {
  if (!value) return '';

  return decodedRichTextToPlainText(decodeRichTextEntities(value));
}

// These elements hold no text of their own but are still something a visitor
// sees, so content containing only these does not count as empty.
const RICH_TEXT_TEXTLESS_VISIBLE_RE = /<(img|video|svg|hr|table)\b/i;

export function hasRichTextContent(value: string | undefined): boolean {
  if (!value) return false;

  const decoded = decodeRichTextEntities(value);
  return (
    RICH_TEXT_TEXTLESS_VISIBLE_RE.test(decoded) || decodedRichTextToPlainText(decoded).length > 0
  );
}
